'use client';

import { useState } from 'react';
import { Modal } from 'ui';
import { useAuthentication } from '@/shared/context/authentication-context';

import { AccountConfirmationModal } from '../accountConfirmationModal';

import { AccountConfirmationProps } from './types';

export function AccountConfirmation({
	accountConfirmation: initialAccountConfirmation,
}: AccountConfirmationProps) {
	const { user } = useAuthentication();

	const [accountConfirmation, setAccountConfirmation] = useState(initialAccountConfirmation);
	const [isAccountConfirmationModalOpen, setIsAccountConfirmationModalOpen] = useState(
		initialAccountConfirmation
	);

	if (user) {
		return null;
	}

	return (
		<Modal
			isOpen={isAccountConfirmationModalOpen}
			onOverlayPress={() => setIsAccountConfirmationModalOpen(false)}
		>
			<AccountConfirmationModal
				accountConfirmation={accountConfirmation}
				handleModalClose={() => setIsAccountConfirmationModalOpen(false)}
				setAccountConfirmation={setAccountConfirmation}
			/>
		</Modal>
	);
}
